/**
 * Analytics identifiers for Pequeñas Puntadas.
 *
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '971936332634523'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
